import React from "react";
import { Form, Row, Col, Button, Accordion } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import ImagePlaceholder from "../../../assets/img/img_placeholder.png";
import X from "../../../assets/img/x.png";
import FileUploadField from "../../../Common/FileUploadField"; // Ensure correct path

export default function PreviousEmploymentSection({
  companyData,
  handleInputChangeCompany,
  addJobSection,
  removeCompanySection,
  deleteFile,
  errors,
  photoLoad,
  isDisabled,
}) {
  const preventLeadingSpace = (e) => {
    if (e.key === " " && e.currentTarget.value.length === 0) {
      e.preventDefault();
    }
  };

  return (
    <div
      className="bg-white p-4 shadow pb-5 rounded-3"
      style={{
        marginLeft: "0.8rem",
        marginRight: "0.8rem",
        marginBottom: "4rem",
      }}
    >
      {/* Heading */}
      <div className="d-flex justify-content-between border-bottom pb-3">
        <h4
          className="text-capitalize icueTextPrimary"
          style={{ color: "#2f4766" }}
        >
          Previous Employment Details
        </h4>
      </div>

      <Accordion className="mt-4">
        {companyData.map((item, index) => (
          <Accordion.Item eventKey={String(index)} key={index}>
            <Accordion.Header>
              <div className="d-flex justify-content-between align-items-center w-100">
                <span>
                  Company {index + 1}: {item.company_name || "Previous Company"}
                </span>
                {companyData.length > 1 && (
                  <FontAwesomeIcon
                    icon={faTrash}
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeCompanySection(index);
                    }}
                    style={{
                      color: "red",
                      cursor: "pointer",
                      fontSize: "18px",
                      marginLeft: "10px",
                      marginRight: "10px",
                    }}
                  />
                )}
              </div>
            </Accordion.Header>

            <Accordion.Body>
              <Row className="mt-3">
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label
                      htmlFor={`companyName-${index}`}
                      style={{ color: "#334d6e" }}
                    >
                      Company Name
                    </Form.Label>
                    <Form.Control
                      className="  text-muted"
                      type="text"
                      id={`companyName-${index}`}
                      name="company_name"
                      value={item.company_name}
                      onKeyDown={preventLeadingSpace}
                      onChange={(e) =>
                        handleInputChangeCompany(e, "job", index)
                      }
                      isInvalid={!!errors?.[`company_name_${index}`]}
                      disabled={isDisabled}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors?.[`company_name_${index}`]}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label
                      htmlFor={`jobTitle-${index}`}
                      style={{ color: "#334d6e" }}
                    >
                      Job Title
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="  text-muted"
                      id={`jobTitle-${index}`}
                      name="job_title"
                      value={item.job_title}
                      onKeyDown={preventLeadingSpace}
                      onChange={(e) =>
                        handleInputChangeCompany(e, "job", index)
                      }
                      isInvalid={!!errors?.[`job_title_${index}`]}
                      disabled={isDisabled}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors?.[`job_title_${index}`]}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label
                      htmlFor={`startDate-${index}`}
                      style={{ color: "#334d6e" }}
                    >
                      Start Date
                    </Form.Label>
                    <Form.Control
                      className="  text-muted"
                      type="date"
                      id={`startDate-${index}`}
                      name="start_date"
                      value={
                        item.start_date
                          ? new Date(item.start_date).toISOString().slice(0, 10)
                          : ""
                      }
                      onChange={(e) =>
                        handleInputChangeCompany(e, "job", index)
                      }
                      isInvalid={!!errors?.[`start_date_${index}`]}
                      disabled={isDisabled}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors?.[`start_date_${index}`]}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label
                      htmlFor={`endDate-${index}`}
                      style={{ color: "#334d6e" }}
                    >
                      End Date
                    </Form.Label>
                    <Form.Control
                      className="  text-muted"
                      type="date"
                      id={`endDate-${index}`}
                      name="end_date"
                      value={
                        item.end_date
                          ? new Date(item.end_date).toISOString().slice(0, 10)
                          : ""
                      }
                      onChange={(e) =>
                        handleInputChangeCompany(e, "job", index)
                      }
                      isInvalid={!!errors?.[`end_date_${index}`]}
                      disabled={isDisabled}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors?.[`end_date_${index}`]}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              {/* File Upload Fields */}
              <Row className="mt-3">
                <Col md={3} style={{ color: "#334d6e" }}>
                  <FileUploadField
                    label="Upload Relieving Letter"
                    name="relieving_letter"
                    value={item.relieving_letter}
                    onChange={(e) => handleInputChangeCompany(e, "job", index)}
                    onDelete={() => deleteFile("relieving_letter", index)}
                    error={errors?.[`relieving_letter_${index}`]}
                    isLoading={photoLoad}
                    placeholder={ImagePlaceholder}
                    deleteIcon={X}
                    isDisabled={isDisabled}
                  />
                </Col>

                <Col md={3} style={{ color: "#334d6e" }}>
                  <FileUploadField
                    label="Upload Resignation Letter"
                    labelColor="#334d6e"
                    name="signed_resignation_letter"
                    value={item.signed_resignation_letter}
                    onChange={(e) => handleInputChangeCompany(e, "job", index)}
                    onDelete={() =>
                      deleteFile("signed_resignation_letter", index)
                    }
                    error={errors?.[`signed_resignation_letter_${index}`]}
                    isLoading={photoLoad}
                    placeholder={ImagePlaceholder}
                    deleteIcon={X}
                    isDisabled={isDisabled}
                  />
                </Col>

                <Col md={3} style={{ color: "#334d6e" }}>
                  <FileUploadField
                    label="Upload Pay Slip"
                    labelColor="#334d6e"
                    name="pay_slip"
                    value={item.pay_slip}
                    onChange={(e) => handleInputChangeCompany(e, "job", index)}
                    onDelete={() => deleteFile("pay_slip", index)}
                    error={errors?.[`pay_slip_${index}`]}
                    isLoading={photoLoad}
                    placeholder={ImagePlaceholder}
                    deleteIcon={X}
                    isDisabled={isDisabled}
                  />
                </Col>

                <Col md={3} style={{ color: "#334d6e" }}>
                  <FileUploadField
                    label="Upload Offer Letter"
                    labelColor="#334d6e"
                    name="offer_letter"
                    value={item.offer_letter}
                    onChange={(e) => handleInputChangeCompany(e, "job", index)}
                    onDelete={() => deleteFile("offer_letter", index)}
                    error={errors?.[`offer_letter_${index}`]}
                    isLoading={photoLoad}
                    placeholder={ImagePlaceholder}
                    deleteIcon={X}
                    isDisabled={isDisabled}
                  />
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>

      {/* Add Company Button */}
      <Button
        variant="primary"
        onClick={addJobSection}
        style={{ marginTop: "20px", marginLeft: "20px" }}
        disabled={isDisabled}
      >
        Add Company
      </Button>
    </div>
  );
}
